import { useQuery } from '@apollo/client';
import { useMeContext } from '~/modules/me/useMeContext';
import { RESOURCE_ALLOCATIONS_QUERY } from '~/modules/resourcing/common/fragments';
import { ResourceCostModeType } from '~/types';

const useProjectResourceAllocationsByIds = ({
  allocationIds,
  resourceCostMode,
  skip = false
}) => {
  const {
    featureFlags: { isRmp2026Q1PerfFixesEnabled }
  } = useMeContext();
  const { loading, data } = useQuery(RESOURCE_ALLOCATIONS_QUERY, {
    variables: {
      filter: {
        resourceAllocationIds: allocationIds
      },
      includeRoleCurrentRate:
        ResourceCostModeType.Rolecost === resourceCostMode,
      includeUserPermittedActions: !isRmp2026Q1PerfFixesEnabled,
      includeUserRoles: !isRmp2026Q1PerfFixesEnabled
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip
  });

  return {
    loadingAllocations: loading,
    resourceAllocations: data?.resourceAllocations?.resourceAllocations || []
  };
};

export default useProjectResourceAllocationsByIds;
